import React from 'react'
import Layout, { Container } from '../components/layout'

const Invoices = () => {
  return (
    <Layout>
        <Container>
    <div>Invoices</div>
            </Container>
    </Layout>
  )
}

export default Invoices